<template>
  <div>
    bought episode list
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
</style>
